<template lang="pug">
  .component-alarm-list-filter-form.filter-form

    .row
      .columns
        input.noBorderClass(v-model = "search.code" placeholder='code')
      .columns
        input.noBorderClass(v-model = "search.source" placeholder='source')
      .columns
        selectize-vehicle(@optionSelected="setVehicleId",  @optionRemoved="unsetVehicleId")

      .columns
        a.fa.fa-search.fa-2x(v-on:click="filterAlarms")
</template>
<script type="text/babel">

  import SelectizeVehicle from '../lists/selectize/SelectizeVehicle'

  export default {
    name: 'AlarmListForm',
    components: {
      SelectizeVehicle,
         },
    data() {
      return {
        vehicles: [],
        search: {
          code: null,
          vehicle_id: null,
          source: null
        }
      }
    },

    created() {
    },
    methods: {

      setVehicleId(vehicle) {

        this.search.vehicle_id = vehicle.id
      },
      filterAlarms() {

        this.$emit('filterAlarms', this.search)
      },

      unsetVehicleId() {
        this.search.vehicle_id = null
      },
    },
    computed: {},
    props: ['type'],
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .noBorderClass
    border-style: none
    border-radius: 6px
</style>



// WEBPACK FOOTER //
// AlarmListForm.vue?329660e6